import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/FeaturesSection.css';

function FeaturesSection() {
  const { t } = useTranslation();
  
  return (
    <section className="features-section" id="use-case-gallery">
      <div className="features-container">
        <div className="feature-item">
          <div className="feature-image-container">
            <img src="/images/page4/main-body.png" alt="Main body of BOBO" className="feature-image" />
            <div className="feature-overlay">
              <p className="feature-hover-text">
                {t('design.nylonSurface')}
              </p>
            </div>
          </div>
          <h3 className="feature-title">{t('design.mainBody')}</h3>
        </div>
        
        <div className="feature-item feature-item-center">
          <div className="feature-image-container">
            <img src="/images/page4/wings.png" alt="Wings of BOBO" className="feature-image" />
            <div className="feature-overlay">
              <p className="feature-hover-text">
                {t('design.omnidirectional')}
              </p>
            </div>
          </div>
          <h3 className="feature-title">{t('design.wings')}</h3>
        </div>
        
        <div className="feature-item">
          <div className="feature-image-container">
            <img src="/images/page4/face.png" alt="Face of BOBO" className="feature-image" />
            <div className="feature-overlay">
              <p className="feature-hover-text">
                {t('design.ledMatrix')}
              </p>
            </div>
          </div>
          <h3 className="feature-title">{t('design.face')}</h3>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection; 